// extracted by mini-css-extract-plugin
module.exports = {"home":"PanoramaHome_home__S1Q9e"};